<kodit-dropdown
  (optionChanged)="handleOnItemChange($event)"
  [ctrlDisabled]="isDisabled"
  [formCtrlId]="formCtrlId"
  [formCtrl]="tipCtrl"
  [options]="items"
></kodit-dropdown>
